export const nullifyEmptyInputs = (data: { [k: string]: any }) => {
  Object.keys(data).forEach(key => {
    if (data[key] === null) return;
    if (typeof data[key] === 'object') nullifyEmptyInputs(data[key]);
    if (data[key] === '') {
      data[key] = null;
    }
  });

  return data;
};
